import React, { Suspense } from 'react'
import { AgGridReactProps } from 'ag-grid-react'

const AgGrid = React.lazy(() => import(/* webpackChunkName: "grid" */ './AgGridImport'))

export const AgGridLazy: React.FunctionComponent<AgGridReactProps> = props => (
  <Suspense fallback={null}>
    <AgGrid {...props} />
  </Suspense>
)
